module.exports = __webpack_public_path__ + "img/wj02_btn.c0f85b31.png";